import { Platform } from 'react-native';

import * as types from '../actions/actionTypes';
import AuthService from '../services/auth_service';
import {
  registerForNotifications as registerForNotificationsService,
  unregisterFromNotifications as unregisterFromNotificationsService,
  requestNotificationsPermissions,
} from './notifications';

let fcmToken = null;

export function disconnectFirebase(disableToken) {
  return async function (dispatch, getState) {
    try {
      unregisterFromNotificationsService();
      if (disableToken && fcmToken) {
        await dispatch(disableFirebaseRegistrationToken(fcmToken));
        fcmToken = null;
      }
    } catch (e) {
      console.error('error in disconnectFirebase', e);
    }
  };
}

export function registerForNotifications() {
  return function (dispatch, getState) {
    return requestNotificationsPermissions()
      .then(() => {
        // console.info('========================= user has granted permission');
        // User has authorised

        registerForNotificationsService((fcmToken) => {
          dispatch(saveFirebaseRegistrationTokenToServer(fcmToken));
        });
        return Promise.resolve(true);
      })
      .catch((error) => {
        // User has rejected permissions
        return Promise.resolve(false);
      });
  };
}

// we might want to check before sending the token if the token has actually child_changed
// since the last time we sent it since firebase.messaging().onTokenRefresh event seems to fire
// whenever the app starts up regardless of whether the token has changed since last launch
function saveFirebaseRegistrationTokenToServer(registrationToken) {
  return function (dispatch, getState) {
    fcmToken = registrationToken;
    const device = {
      os: Platform.OS,
      registrationToken: registrationToken,
    };
    // Don't save the token twice. This can happen for first time install when getToken is called explicitly
    // and onTokenRefresh listener is added and gets called.
    if (
      !getState().user.firebaseRegistrationTokenSending &&
      (getState().user.firebaseRegistrationLastToken === null ||
        getState().user.firebaseRegistrationLastToken !== registrationToken)
    ) {
      dispatch({
        types: [
          types.AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_REQUEST,
          types.AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_SUCCESS,
          types.AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_FAILURE,
        ],
        promise: AuthService.saveFirebaseRegistrationToken(device),
      });
    }
  };
}

function disableFirebaseRegistrationToken(fcmToken) {
  return {
    types: [
      types.AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_REQUEST,
      types.AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_SUCCESS,
      types.AUTH_DISABLE_FIREBASE_REGISTRATION_TOKEN_FAILURE,
    ],
    promise: AuthService.disableFirebaseRegistrationToken(fcmToken),
  };
}
